var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEstimator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9745 2.91782L7.22114 0.529375C7.07714 0.469375 6.91492 0.469375 6.77092 0.529375L1.01803 2.91782C0.798917 3.00893 0.65625 3.22271 0.65625 3.46004V6.3636C0.65625 10.3618 3.07269 13.9583 6.77447 15.4694C6.91669 15.5276 7.07581 15.5276 7.21803 15.4694C10.9198 13.9583 13.3362 10.3618 13.3362 6.3636V3.46004C13.3362 3.22271 13.1936 3.00893 12.9745 2.91782ZM12.1625 6.3636C12.1625 9.76271 10.1665 12.8916 6.99625 14.288C3.91092 12.9285 1.83003 9.85471 1.83003 6.3636V3.8516L6.99625 1.70671L12.1625 3.8516V6.3636ZM6.34736 8.34226L8.87047 5.81915C9.09981 5.58982 9.47136 5.58982 9.70069 5.81915C9.93003 6.04849 9.93003 6.42004 9.70069 6.64938L6.76247 9.5876C6.53314 9.81693 6.16158 9.81693 5.93225 9.5876L4.29181 7.94715C4.06247 7.71782 4.06247 7.34626 4.29181 7.11693C4.52114 6.8876 4.89269 6.8876 5.12203 7.11693L6.34736 8.34226Z",
    fill: "#416EB2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimator);
export default __webpack_public_path__ + "static/media/estimator.b46def3a7fa4be8654772f1488967005.svg";
export { ForwardRef as ReactComponent };